import AfricanIconHover from 'src/assets/icons/hover/svg/African-Cuisine-Icon_Injera_200x200px_Colour-HOVER.svg';
import AllIconHover from 'src/assets/icons/hover/svg/All-Cuisine-Icon_Globe_200x200px_Colour-HOVER.svg';
import AmericanIconHover from 'src/assets/icons/hover/svg/american-dynamic-200.svg';
import BengaliIconHover from 'src/assets/icons/hover/svg/Bengali-Cuisine-Icon_200x200px_Colour-HOVER.svg';
import CaribbeanIconHover from 'src/assets/icons/hover/svg/Brazilian-Cuisine-Icon_Carved-Meat_200x200px_Colour-HOVER.svg';
import ChineseIconHover from 'src/assets/icons/hover/svg/Chinese-Cuisine-Icon_Spring-Rolls_200x200px_Colour-HOVER.svg';
import IndianIconHover from 'src/assets/icons/hover/svg/Indian-Cuisine-Icon_Curry-Pot_200x200px_Colour-HOVER.svg';
import ItalianIconHover from 'src/assets/icons/hover/svg/Italian-Cuisine-Icon_Spaghetti-Bolognese_200x200px_Colour-HOVER.svg';
import JapaneseIconHover from 'src/assets/icons/hover/svg/Japanese-Cuisine-Icon_Sushi_200x200px_Colour-HOVER.svg';
import KoreanIconHover from 'src/assets/icons/hover/svg/Korean-Cuisine-Icon_KBBQ_200x200px_Colour-HOVER.svg';
import LatinIconHover from 'src/assets/icons/hover/svg/Latin-American-Cuisine-Icon_Rice-Beans_200x200px_Colour-HOVER.svg';
import MediterraneanIconHover from 'src/assets/icons/hover/svg/Mediterranean-Cuisine-Icon_Greek-Salad-Falafels_200x200px_Colour-HOVER.svg';
import MexicanIconHover from 'src/assets/icons/hover/svg/Mexican-Cuisine-Icon_Tacos_200x200px_Colour-HOVER.svg';
import MiddleEastIconHover from 'src/assets/icons/hover/svg/Middle-East-Cuisine-Icon_Kebob-Sticks_200x200px_Colour-HOVER.svg';
import MoreIconHover from 'src/assets/icons/hover/svg/More-Cuisine-Icon_Pan-Ingredients_200x200px_Colour-HOVER.svg';
import NepaliIconHover from 'src/assets/icons/hover/svg/Nepalese-Cuisine-Icon_Momo_200x200px_Colour-HOVER.svg';
import NorthIndianIconHover from 'src/assets/icons/hover/svg/North-Indian-Cuisine-Icon_200x200px_Colour-HOVER.svg';
import PakistaniIconHover from 'src/assets/icons/hover/svg/Pakistani-Cuisine-Icon_Samosa_200x200px_Colour-HOVER.svg';
import SouthIndianIconHover from 'src/assets/icons/hover/svg/South-Indian-Cuisine-Icon_200x200px_Colour-HOVER.svg';
import SouthernIconHover from 'src/assets/icons/hover/svg/Southern-US-Cuisine-Icon_Fried-Chicken-Ribs_200x200px_Colour-HOVER.svg';
import SpecialtyIconHover from 'src/assets/icons/hover/svg/Specialty-Icon-HOVER.svg';
import ThaiIconHover from 'src/assets/icons/hover/svg/Thai-Cuisine-Icon_Pad-Thai_200x200px_Colour-HOVER.svg';
import AfricanIcon from 'src/assets/icons/static/svg/African-Cuisine-Icon_Injera_200x200px_Colour-STATIC.svg';
import AllIcon from 'src/assets/icons/static/svg/All-Cuisine-Icon_Globe_200x200px_Colour-STATIC.svg';
import AmericanIcon from 'src/assets/icons/static/svg/american-static-200.svg';
import BengaliIconStatic from 'src/assets/icons/static/svg/Bengali-Cuisine-Icon_200x200px_Colour-STATIC.svg';
import CaribbeanIcon from 'src/assets/icons/static/svg/Brazilian-Cuisine-Icon_Carved-Meat_200x200px_Colour-STATIC.svg';
import ChineseIcon from 'src/assets/icons/static/svg/Chinese-Cuisine-Icon_Spring-Rolls_200x200px_Colour-STATIC.svg';
import IndianIcon from 'src/assets/icons/static/svg/Indian-Cuisine-Icon_Curry-Pot_200x200px_Colour-STATIC.svg';
import ItalianIcon from 'src/assets/icons/static/svg/Italian-Cuisine-Icon_Spaghetti-Bolognese_200x200px_Colour-STATIC.svg';
import JapaneseIcon from 'src/assets/icons/static/svg/Japanese-Cuisine-Icon_Sushi_200x200px_Colour-STATIC.svg';
import KoreanIcon from 'src/assets/icons/static/svg/Korean-Cuisine-Icon_KBBQ_200x200px_Colour-STATIC.svg';
import LatinIcon from 'src/assets/icons/static/svg/Latin-American-Cuisine-Icon_Rice-Beans_200x200px_Colour-STATIC.svg';
import MediterraneanIcon from 'src/assets/icons/static/svg/Mediterranean-Cuisine-Icon_Greek-Salad-Falafels_200x200px_Colour-STATIC.svg';
import MexicanIcon from 'src/assets/icons/static/svg/Mexican-Cuisine-Icon_Tacos_200x200px_Colour-STATIC.svg';
import MiddleEastIcon from 'src/assets/icons/static/svg/Middle-East-Cuisine-Icon_Kebob-Sticks_200x200px_Colour-STATIC.svg';
import MoreIcon from 'src/assets/icons/static/svg/More-Cuisine-Icon_Pan-Ingredients_200x200px_Colour-STATIC.svg';
import NepaliIcon from 'src/assets/icons/static/svg/Nepalese-Cuisine-Icon_Momo_200x200px_Colour-STATIC.svg';
import NorthIndianIconStatic from 'src/assets/icons/static/svg/North-Indian-Cuisine-Icon_200x200px_Colour-STATIC.svg';
import PakistaniIcon from 'src/assets/icons/static/svg/Pakistani-Cuisine-Icon_Samosa_200x200px_Colour-STATIC.svg';
import SouthIndianIconStatic from 'src/assets/icons/static/svg/South-Indian-Cuisine-Icon_200x200px_Colour-STATIC.svg';
import SouthernIcon from 'src/assets/icons/static/svg/Southern-US-Cuisine-Icon_Fried-Chicken-Ribs_200x200px_Colour-STATIC.svg';
import SpecialtyIcon from 'src/assets/icons/static/svg/Specialty-Icon-STATIC.svg';
import ThaiIcon from 'src/assets/icons/static/svg/Thai-Cuisine-Icon_Pad-Thai_200x200px_Colour-STATIC.svg';
import { SegmentFilter } from 'src/gqlReactTypings.generated.d';

export interface SegmentDisplayInfo {
  icon: string;
  hoverIcon: string;
  title: string;
  style?: React.CSSProperties;
}

export enum DefinedSubcuisines {
  NORTH_INDIAN = 'NORTH_INDIAN',
  SOUTH_INDIAN = 'SOUTH_INDIAN',
  BENGALI = 'BENGALI',
}

export const SegmentFilterDisplayInfo: { [filter in SegmentFilter | DefinedSubcuisines]?: SegmentDisplayInfo } = {
  [SegmentFilter.All]: { icon: AllIcon, hoverIcon: AllIconHover, title: 'All' },
  [SegmentFilter.Indian]: { icon: IndianIcon, hoverIcon: IndianIconHover, title: 'Indian' },
  SOUTH_INDIAN: { icon: SouthIndianIconStatic, hoverIcon: SouthIndianIconHover, title: 'South Indian' },
  NORTH_INDIAN: { icon: NorthIndianIconStatic, hoverIcon: NorthIndianIconHover, title: 'North Indian' },
  BENGALI: { icon: BengaliIconStatic, hoverIcon: BengaliIconHover, title: 'Bengali' },
  [SegmentFilter.Chinese]: { icon: ChineseIcon, hoverIcon: ChineseIconHover, title: 'Chinese' },
  [SegmentFilter.MiddleEastern]: {
    icon: MiddleEastIcon,
    hoverIcon: MiddleEastIconHover,
    title: 'Middle Eastern',
  },
  [SegmentFilter.Nepalese]: { icon: NepaliIcon, hoverIcon: NepaliIconHover, title: 'Nepalese' },
  [SegmentFilter.Mexican]: { icon: MexicanIcon, hoverIcon: MexicanIconHover, title: 'Mexican' },
  [SegmentFilter.Korean]: { icon: KoreanIcon, hoverIcon: KoreanIconHover, title: 'Korean' },
  [SegmentFilter.African]: { icon: AfricanIcon, hoverIcon: AfricanIconHover, title: 'African' },
  [SegmentFilter.Southern]: { icon: SouthernIcon, hoverIcon: SouthernIconHover, title: 'Southern' },
  [SegmentFilter.Pakistani]: {
    icon: PakistaniIcon,
    hoverIcon: PakistaniIconHover,
    title: 'Pakistani',
  },
  [SegmentFilter.Mediterranean]: {
    icon: MediterraneanIcon,
    hoverIcon: MediterraneanIconHover,
    title: 'Mediterranean',
  },
  [SegmentFilter.Caribbean]: { icon: CaribbeanIcon, hoverIcon: CaribbeanIconHover, title: 'Caribbean' },
  [SegmentFilter.LatinAmerican]: { icon: LatinIcon, hoverIcon: LatinIconHover, title: 'Latin American' },
  [SegmentFilter.Italian]: { icon: ItalianIcon, hoverIcon: ItalianIconHover, title: 'Italian' },
  [SegmentFilter.Japanese]: { icon: JapaneseIcon, hoverIcon: JapaneseIconHover, title: 'Japanese' },
  [SegmentFilter.SoutheastAsian]: {
    icon: ThaiIcon,
    hoverIcon: ThaiIconHover,
    title: 'Southeast Asian',
  },
  [SegmentFilter.American]: {
    icon: AmericanIcon,
    hoverIcon: AmericanIconHover,
    style: { padding: '8px' },
    title: 'American',
  },
  [SegmentFilter.BakedGoods]: {
    icon: SpecialtyIcon,
    hoverIcon: SpecialtyIconHover,
    title: 'Baked Goods',
    style: { padding: '6px' },
  },
  [SegmentFilter.More]: { icon: MoreIcon, hoverIcon: MoreIconHover, title: 'More Cuisines' }, // Keep at the end
};
